<template>
  <v-app class="triangles-pattern">
    <the-navigation></the-navigation>

    <v-main>
      <router-view />
    </v-main>

    <the-footer></the-footer>
  </v-app>
</template>


<script>
import TheFooter from "./components/TheFooter.vue";
import TheNavigation from "./components/TheNavigation.vue";

export default {
  name: 'App',
  components: {
    TheFooter,
    TheNavigation,
  }
}
</script>

<style>
html {
  overflow-y: auto !important;
}

.triangles-pattern {
  background-image: url('~@/assets/static/triangles.webp') !important;
  background-repeat: repeat !important;
}
</style>
